"use strict";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.Blob = void 0;
const gsap_1 = require("gsap");
class Blob {
    static init() {
        document.addEventListener('DOMContentLoaded', () => {
            if (localized && localized.blobs.length) {
                const pageWrap = document.getElementById('page-container');
                const blobsWrap = document.createElement('div');
                blobsWrap.classList.add('blob-wrap');
                pageWrap.prepend(blobsWrap);
                localized.blobs.forEach((blob) => {
                    Blob.createBlob(blob, blobsWrap);
                });
            }
        });
    }
    static randomFloat(min, max) {
        return Math.random() * (max - min) + min;
    }
    static randomInt(min, max) {
        return Math.floor(this.randomFloat(min, max));
    }
    static createBlob(blob, blobsWrap) {
        const blobVideo = document.createElement('video');
        blobVideo.dataset.align = blob.position;
        blobVideo.style.opacity = 0;
        blobVideo.style.scale = blob.scale;
        blobVideo.autoplay = true;
        blobVideo.loop = true;
        blobVideo.muted = true;
        blobsWrap.append(blobVideo);
        const videoKey = this.randomInt(1, 5);
        const videoWebmSrc = document.createElement('source');
        videoWebmSrc.src = `/app/themes/lyfter-child/img/blobs/blob${videoKey}.webm`;
        blobVideo.append(videoWebmSrc);
        const videoMp4Src = document.createElement('source');
        videoMp4Src.src = `/app/themes/lyfter-child/img/blobs/blob${videoKey}.mp4`;
        blobVideo.append(videoMp4Src);
        blobVideo.play();
        gsap_1.gsap.to(blobVideo, { opacity: 1, duration: 0.5, delay: 1.5 });
    }
}
exports.Blob = Blob;
